module.exports = __webpack_public_path__ + "img/back2.8a315923.png";